<template>
    <div class="mt-3 w-100">
        <b-row class="text-right">
            <b-col>
                <b-pagination
                    hide-goto-end-buttons
                    align="right"
                    size="md"
                    class="custom-pagination"
                    :total-rows="(voucherCodesPagination.totalPerPage > 0) ? voucherCodesPagination.maxPage * voucherCodesPagination.totalPerPage : 1"
                    :limit="(voucherCodesPagination.totalPerPage > 0) ? 5 : 1"
                    :per-page="voucherCodesPagination.totalPerPage"
                    v-model="voucherCodesPagination.currentPage"
                    @change="paginate">
                </b-pagination>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "VoucherCodesPagination",
    props: ["filters"],
    computed: {
        ...mapState("estoreVouchers", [
            "voucherCodesPagination",
            "modal"
        ])
    },
    methods: {
        paginate: async function(page) {
            let param = {
                page: page,
                payload: {
                    store_voucher_uuid: this.modal.storeVouchers.uuid,
                    filters: this.filters
                }
            };
            await this.$store.dispatch("estoreVouchers/viewStoreVoucherCodes", param);
        }
    }
};
</script>
